import { render, staticRenderFns } from "./SVG.vue?vue&type=template&id=1f57b23c&"
import script from "./SVG.vue?vue&type=script&lang=js&"
export * from "./SVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports